import ControllerBase from 'global/js/ControllerBase';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { MoleculeSearchFieldEvents, MoleculeSearchFieldEvent } from 'wolf/components/molecules/m-search-field/m-search-field.events';
import { MoleculePaginationEvent, MyMoleculePaginationEvents } from 'wolf/components/molecules/m-pagination/m-pagination.events';
import ControllerProxy from 'global/js/ControllerProxy';
import Controller from '../../../global/js/controller';


interface ComponentRefs {
	categoriesWrapper: 'categoriesWrapper';
	contentWrapper: 'contentWrapper';
}

export default class ControllerAdviser extends ControllerBase<ComponentRefs> {
	private categories: HTMLDivElement;
	private filter: string;
	private searchUrl: string;
	private page: number;
	private content: HTMLDivElement;
	private searchTerm: string;

	constructor(element: HTMLElement) {
		super(element);

		this.searchUrl = this.$element.dataset.searchurl as string;
		this.categories = this.$references.categoriesWrapper as HTMLDivElement;
		this.content = this.$references.contentWrapper as HTMLDivElement;
		this.filter = '';
		this.searchTerm = '';
		this.page = 1;

		this.init();
	}

	private init(): void {
		this.searchEvent();
		this.paginationEvent();

		this.categories.querySelectorAll('li').forEach((category: HTMLLIElement) => {
			category.addEventListener('click', (event) => this.handleClickEvent(event));
		});
	}

	/**
	 * Applies a tag if required to filter in the API call
	 * @param event
	 */
	private handleClickEvent(event: MouseEvent | PointerEvent): void {
		const category = event.target as HTMLLIElement;
		const categories = this.categories.querySelectorAll('li');

		if (category.classList.contains('active')) {
			categories.forEach((tag) => {
				tag.classList.remove('active');
				this.filter = '';
			});
		} else {
			categories.forEach((tag) => {
				tag.classList.remove('active');
			});
			category.classList.add('active');
			this.filter = category.dataset.category || '';
		}
		this.search(this.searchTerm)
			.then((response) => {
				this.renderContent(response.data);
			})
			.catch((err) => {
				console.error(err);
			});
	}

	/**
	 * API call
	 * @param {string} input Keyword to be search in the API call
	 */
	private async search(input: string) {
		const url = new URL(this.searchUrl);
		url.searchParams.append('search', input);
		this.filter ? url.searchParams.append('tag', this.filter) : '';
		url.searchParams.append('page', this.page.toString());

		const response = await fetch(url.toString());

		return await response.json();
	}

	private searchEvent() {
		fromEvent(window, MoleculeSearchFieldEvents.search)
			.pipe(
				map((event: CustomEvent<MoleculeSearchFieldEvent>) => {
					return event.detail.searchValue || '';
				}),
			)
			.subscribe((e) => {
				this.searchTerm = e;
				this.search(this.searchTerm)
					.then((response) => {
						this.renderContent(response.data);
					})
					.catch((err) => {
						console.error(err);
					});
			});
	}

	private paginationEvent() {
		fromEvent(window, MyMoleculePaginationEvents.pageEvent)
			.pipe(
				map((event: CustomEvent<MoleculePaginationEvent>) => {
					return event.detail.page || -1;
				}),
			)
			.subscribe((e) => {
				this.page = e > -1 ? e : 1;
				this.search(this.searchTerm).then((response) => {
					this.renderContent(response.data);
				});
			});
	}

	private renderContent(content: string) {
		this.content.innerHTML = content;

		this.initializeNestedComponents();
	}

	protected initializeNestedComponents(): void {
		const components = this.content.querySelectorAll('[data-controller]');

		components.forEach((element: HTMLElement) => {
			const componentName = <string>element.dataset.controller;
			new ControllerProxy(Controller, componentName, element);
		});
	}
}
